import React from "react";
import { notification } from "antd";

type NotificationType = "success" | "info" | "warning" | "error";

interface Props {
  type: NotificationType;
  message: string;
  description?: string;
}

const openNotificationWithIcon = ({ type, message, description }: Props) => {
  notification[type]({
    message,
    description,
  });
};

export default openNotificationWithIcon;
